/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Yasin Price",
  title: "Hey I'm Yasin!",
  subTitle: emoji(
    "I'm a passionate Full Stack Software Developer 🚀, I'm experienced in building Web applications with JavaScript / Reactjs / Nodejs / Rails / Google Cloud Platform and some other cool libraries and frameworks."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/YsPrice",
  linkedin: "https://www.linkedin.com/in/yasin-price-46a581218/",
  gmail: "ys.price28@gmail.com",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "As an adept full stack developer deeply immersed in a diverse array of technologies and stacks, crafting versatile solutions that seamlessly bridge frontend and backend landscapes.",
  skills: [
    emoji(
      "⚡ Develop highly interactive Full Stack Applications, REST API's and scalable seamless software!"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase / Google Cloud / Docker"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
  
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
 
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
   
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "JavaScript/React.js", //Insert stack or technology you have experience in

    },
    {
      Stack: "Ruby/Ruby on Rails",

    },
    {
      Stack: "Node.js",

    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Freelance Software Engineer",
      company: "Freelancer",
      companylogo: require("./assets/images/codeicon.png"),
      date: "January 2023 – Current",
      desc: `As a Full Stack Developer, I led the development and deployment of over 7 full stack web applications, enhancing clients' digital presence and operational efficiency.
      I specialized in creating robust databases and integrating RESTful APIs, achieving a 30% improvement in data retrieval times and a 25% reduction in server response times.`
    },
    {
      role: "Software Engineer",
      company: "Mahogany's Classy Closet Inc",
      companylogo: require("./assets/images/Mhl.png"),
      date: "Jan 2019 – Current",
      desc:"I enhanced user interfaces with React components, prioritizing intuitive experiences and employing Redux for streamlined performance. On the backend, I optimized data handling and API integration to improve efficiency and reduce load times. By implementing and maintaining robust contact forms and dynamic product listings, I increased user satisfaction and drove measurable sales growth. As the overseer of web development, I led full-stack enhancements, including backend optimization and deployment strategies, resulting in a 20% increase in user retention and a 15% growth in site traffic, directly impacting revenue."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My Projects",
  display:true,
  subtitle: "Some of my favorite projects I've built!",
  projects: [
    { image:"https://res.cloudinary.com/ducg1tnoi/image/upload/v1736947010/quizApp_sfeyuy.png",
      projectName:'Full Stack/DevOps Quiz Application',
      projectDesc:`I built a full-stack quiz application that showcases my ability to design and implement a dynamic, user-focused platform from scratch. The frontend, developed with React and Redux (along with Redux Persist for persisting state throughout sessions), delivers a seamless user experience for creating, taking, and managing quizzes, while the backend, powered by Node.js, Prisma, GraphQL, and PostgreSQL, ensures secure and efficient data management. Key features include token-based authentication for account creation and login, detailed user metrics (quizzes taken and created), and flexible quiz functionality. Users can create, save, update, publish, and search quizzes with ease.
For deployment, I implemented containerized solutions using Docker, hosted and managed with Google Cloud and Kubernetes for scalability and reliability. This involved writing multiple .yaml scripts to configure deployments and services, reinforcing my understanding of modern DevOps practices. The project highlights my skills in building full-stack applications with an emphasis on clean, maintainable code, intuitive design, and scalable infrastructure, which are all essential for delivering robust, production-ready solutions. 

*WARNING* for cost efficiency reasons this app is hosted from 7am to 12am EST. Thank you for understanding.
`,
footerLink:[
  {
name:"visit Website",
url:"https://quiz-app-fe-nine.vercel.app/"
  }
]
    },
    {
      image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1736947010/maho_zefa31.png",
      projectName: "Mahogany's Classy Closet E-commerce",
      projectDesc: "I built a dynamic e-commerce platform using Ecwid for product management and payments, alongside React and Redux for the front end. The site allows users to browse products, manage their shopping cart, and securely check out. Redux handled state management to ensure smooth performance, even as the store scaled. I focused on creating a responsive, user-friendly interface that works seamlessly across devices, integrating features like product filtering and order tracking to enhance the shopping experience.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.mahoganyacc.com/"
        },
      
        
        
        //  you can add extra buttons here.
      ]
    },
    {
      image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1736947010/sfe_blyyuc.png",
      projectName: "Street Fighter Themed E-commerce Web Application",
      projectDesc: "This project is a full-stack e-commerce web application that brings the iconic world of Street Fighter into the realm of online shopping. At its core, it's a Ruby on Rails API coupled with a React.js frontend, offering a seamless and interactive user experience. The application features a range of Street Fighter character-themed products, enabling fans to browse, search, and purchase their favorite items. It includes robust functionalities such as token-based user authentication, dynamic product filtering, and a comprehensive cart management system. Users can effortlessly add items to their cart, adjust quantities, and proceed to checkout.",
      footerLink: [
        {
          name: "Visit Repository",
          url: "https://github.com/YsPrice/sf-ecommerce"
        },
      
        
        

      ]
    },
    {
      image:"https://res.cloudinary.com/ducg1tnoi/image/upload/v1736947010/hoodsh_uecpio.png",
      projectName: "Hood Shaw Memorial Landing Site",
      projectDesc: "I built this modern and responsive landing page for my local church, showcasing my ability to craft engaging web experiences tailored to real-world needs. Using React along with Bootstrap for styling and layout, I created a fully functional contact form integrated with EmailJS to facilitate seamless communication, ensuring visitors could easily reach out for inquiries or prayer requests. The design emphasizes a mobile-first, responsive layout that adapts seamlessly across devices, providing smooth navigation and accessibility. To enhance the user experience, I incorporated a clean, contemporary UI with dynamic animations and hover effects that bring the site to life. This project demonstrates my skills in building practical, visually appealing web solutions with a focus on functionality and modern design.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.hoodshawmemorial.com/"
        },
      
        
        
        //  you can add extra buttons here.
      ]
    }

  ],
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false// Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false// Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to hire me or just want to say hi? My Inbox is open!",
  email_address: "ys.price28@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
